import { render, staticRenderFns } from "./CompanionDetails.vue?vue&type=template&id=4ff024b6&scoped=true"
import script from "./CompanionDetails.vue?vue&type=script&lang=js"
export * from "./CompanionDetails.vue?vue&type=script&lang=js"
import style0 from "./CompanionDetails.vue?vue&type=style&index=0&id=4ff024b6&prod&lang=css"
import style1 from "./CompanionDetails.vue?vue&type=style&index=1&id=4ff024b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff024b6",
  null
  
)

export default component.exports